import React from 'react';

import { Value } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import { default as _TypeConfig } from '../common/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function _ContactMeta(props) { return <Value {...props} value={props.content} /> }
const ContactMeta = Token.withContentTokenParsing(
    _ContactMeta,
    {
        // extraParseConditionHandler: (props) => {
        //     if (props.config && props.config.config && props.config.config.Block) {
        //         return [props.config.config.Block.addressType];
        //     }
        //     return [];
        // }
    },
    (props, keyword, options) => {
        const data = props.data || {};
        const client = data.Client || {};
        // const blockConfig = props.config && props.config.config && props.config.config.Block || {};
        // const address = blockConfig.addressType == 'shipping' ? client.ShippingAddress : client.BillingAddress;
        const address = client.ShippingAddress;
        let replaceString = '';
        switch (keyword) {
            // case Token.Address.City:
            //     if (address && !Utilities.isNullOrWhitespace(address.City)) {
            //         replaceString = Token.getReplacementString(address.City, options);
            //     }
            //     break;
            case Token.Address.Country:
                if (address && !Utilities.isNullOrWhitespace(address.Country)) {
                    replaceString = Token.getReplacementString(address.Country, options);
                }
                break;
            case Token.Address.Line1:
                if (address && !Utilities.isNullOrWhitespace(address.LineOne)) {
                    replaceString = Token.getReplacementString(address.LineOne, options);
                }
                break;
            case Token.Address.Line2:
                if (address && !Utilities.isNullOrWhitespace(address.LineTwo)) {
                    replaceString = Token.getReplacementString(address.LineTwo, options);
                }
                break;
            case Token.Address.Location:
                if (address && !Utilities.isNullOrWhitespace(address.LocationWithZip)) {
                    replaceString = Token.getReplacementString(address.LocationWithZip, options);
                }
                break;
            // case Token.Address.State:
            //     if (address && !Utilities.isNullOrWhitespace(address.State)) {
            //         replaceString = Token.getReplacementString(address.State, options);
            //     }
            //     break;
            // case Token.Address.Zip:
            //     if (address && !Utilities.isNullOrWhitespace(address.Zip)) {
            //         replaceString = Token.getReplacementString(address.Zip, options);
            //     }
            //     break;
            case Token.CompanyName:
                if (!Utilities.isNullOrWhitespace(client.Company)) {
                    replaceString = Token.getReplacementString(client.Company, options);
                }
                break;
            case Token.Email:
                if (!Utilities.isNullOrWhitespace(client.Email)) {
                    replaceString = Token.getReplacementString(client.Email, options);
                }
                break;
            case Token.Name:
                if (!Utilities.isNullOrWhitespace(client.Name)) {
                    replaceString = Token.getReplacementString(client.Name, options);
                }
                break;
            case Token.Phone.Home:
                if (!Utilities.isNullOrWhitespace(client.PhoneHome)) {
                    replaceString = Token.getReplacementString(client.PhoneHome, options);
                }
                break;
            case Token.Phone.Mobile:
                if (!Utilities.isNullOrWhitespace(client.PhoneMobile)) {
                    replaceString = Token.getReplacementString(client.PhoneMobile, options);
                }
                break;
            case Token.Phone.Other:
                if (!Utilities.isNullOrWhitespace(client.PhoneOther)) {
                    replaceString = Token.getReplacementString(client.PhoneOther, options);
                }
                break;
            case Token.SpouseName:
                if (!Utilities.isNullOrWhitespace(client.SpouseName)) {
                    replaceString = Token.getReplacementString(client.SpouseName, options);
                }
                break;
            default:
                replaceString = undefined;
                break;
        }
        return replaceString;
    }
);
const Tokens = () => [
    Token.getWrappedTokenConfig('Contact Name', Token.Name),
    Token.getWrappedTokenConfig('Spouse Name', Token.SpouseName),
    Token.getWrappedTokenConfig('Company Name', Token.CompanyName),
    Token.getWrappedTokenConfig('Address Line 1', Token.Address.Line1),
    Token.getWrappedTokenConfig('Address Line 2', Token.Address.Line2),
    Token.getWrappedTokenConfig('Location', Token.Address.Location),
    // Token.getWrappedTokenConfig('City', Token.Address.City),
    // Token.getWrappedTokenConfig('State', Token.Address.State),
    // Token.getWrappedTokenConfig('Zip', Token.Address.Zip),
    Token.getWrappedTokenConfig('Country', Token.Address.Country),
    Token.getWrappedTokenConfig('Home Phone', Token.Phone.Home),
    Token.getWrappedTokenConfig('Mobile Phone', Token.Phone.Mobile),
    Token.getWrappedTokenConfig('Other Phone', Token.Phone.Other),
    Token.getWrappedTokenConfig('Email Address', Token.Email)
];
const TypeConfig = {
    panel: {
        block: () => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    // {
                    //     display: 'Address Type',
                    //     group,
                    //     name: 'addressType',
                    //     options: [
                    //         { display: 'Billing', value: 'billing' },
                    //         { display: 'Shipping', value: 'shipping' }
                    //     ],
                    //     type: 'dropdown',
                    //     value: 'billing'
                    // },
                    {
                        display: 'Display Text',
                        fullWidth: true,
                        group,
                        name: 'design',
                        type: 'rich-text-collateral',
                        value: `${Utilities.wrapTextForEditor({ text: 'Contact', textExtras: `style="font-weight:bold;"`})}${Utilities.wrapTextForEditor({ text: `{${Token.Name}("before":"","after":"")}`, token: Token.Name })}${Utilities.wrapTextForEditor({ text: `{${Token.SpouseName}("before":"","after":"")}`, token: Token.SpouseName })}${Utilities.wrapTextForEditor({ text: `{${Token.CompanyName}("before":"","after":"")}`, token: Token.CompanyName })}${Utilities.wrapTextForEditor({ text: `{${Token.Address.Line1}("before":"","after":"")}`, token: Token.Address.Line1 })}${Utilities.wrapTextForEditor({ text: `{${Token.Address.Line2}("before":"","after":"")}`, token: Token.Address.Line2 })}${Utilities.wrapTextForEditor({ text: `{${Token.Address.Location}("before":"","after":"")}`, token: Token.Address.Location })}${Utilities.wrapTextForEditor({ text: `{${Token.Address.Country}("before":"","after":"")}`, token: Token.Address.Country })}${Utilities.wrapTextForEditor({ text: `{${Token.Phone.Home}("before":"","after":"")}`, token: Token.Phone.Home })}${Utilities.wrapTextForEditor({ text: `{${Token.Phone.Mobile}("before":"","after":"")}`, token: Token.Phone.Mobile })}${Utilities.wrapTextForEditor({ text: `{${Token.Phone.Other}("before":"","after":"")}`, token: Token.Phone.Other })}${Utilities.wrapTextForEditor({ text: `{${Token.Email}("before":"","after":"")}`, token: Token.Email })}`
                    }
                ]
            };
        },
        style: () => _TypeConfig.panel.layoutStyle('style', 'Layout')
    }
};

export {
    ContactMeta as Component,
    Tokens,
    TypeConfig
};